"use client";

import { c as _c } from "react/compiler-runtime";
import { RefObject, useCallback } from "react";
import { useMotionValue, useSpring } from "framer-motion";

// Tracks the pointer inside a container and hands back springy coordinates for
// a floating preview to sit on.
//
// Motion values, not state: the pointer moves on every frame, and putting that
// through React would re-render the whole list of rows a hundred times a
// second. The values are written straight to the transform instead.
export const useCursorPreview = containerRef => {
  const $ = _c(9);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      stiffness: 200,
      damping: 24,
      mass: 0.5
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const springConfig = t0;
  const smoothX = useSpring(x, springConfig);
  const smoothY = useSpring(y, springConfig);
  let t1;
  if ($[1] !== containerRef || $[2] !== x || $[3] !== y) {
    t1 = event => {
      const bounds = containerRef.current?.getBoundingClientRect();
      if (!bounds) {
        return;
      }
      x.set(event.clientX - bounds.left);
      y.set(event.clientY - bounds.top);
    };
    $[1] = containerRef;
    $[2] = x;
    $[3] = y;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onMouseMove = t1;
  let t2;
  if ($[5] !== onMouseMove || $[6] !== smoothX || $[7] !== smoothY) {
    t2 = {
      x: smoothX,
      y: smoothY,
      onMouseMove
    };
    $[5] = onMouseMove;
    $[6] = smoothX;
    $[7] = smoothY;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};